<template>
  <div class="dialog-container wt-dialog-container">
    <div v-loading="isGarbageDeliveryTypeDetailLoading">
      <wt-detail-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm">
        <template slot="isShow">
          <el-switch :active-value="1" :inactive-value="2" v-model="detailFormData.isShow"> </el-switch>
        </template>
      </wt-detail-form-section>
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'DeliveryHomeApplianceTypeEdit',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      formCode: 'MODULES_GARBAGEDELIVERYTYPE',
      isSubmitLoading: false,
      formUpdateUrl: '/modules/garbageDeliveryType/garbageDeliveryTypeUpdate',
      formAddUrl: '/modules/garbageDeliveryType/garbageDeliveryTypeAdd',
      detailFormButtons: {
        title: '详情',
        elements: [{ name: '提交', key: 'ADD', action: 'ADD', className: 'primary', hidden: this.componentType !== 'add' },
          { name: '提交', key: 'EDIT', action: 'EDIT', className: 'primary', hidden: this.componentType !== 'edit' },
          { name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      detailForm: {
        title: '基本信息',
        elements: [
          { name: '物品名称',
            key: 'name',
            type: 'text',
            required: true,
            disabled: false,
            rules: [
              { min: 1, max: 20, message: '物品名称长度不能超过20', trigger: 'blur' }
            ] },
          { name: '兑换积分(个)',
            key: 'integral',
            type: 'text',
            required: true,
            disabled: false,
            rules: [
              { validator: this.$wtValidator.ValidatorGreaterZeroInt, trigger: 'blur' },
              { validator: this.$wtValidator.ValidatorMaxIntegral, trigger: 'blur' }
            ] },
          { name: '减少树木砍伐(颗/个)',
            key: 'tree',
            type: 'text',
            required: true,
            disabled: false,
            rules: [
              { validator: this.$wtValidator.ValidatorGreaterZeroFloat, trigger: 'blur' },
              { validator: this.$wtValidator.ValidatorEMax, trigger: 'blur' }
            ] },
          { name: '减少碳排放(kg/个)',
            key: 'carbon',
            type: 'text',
            required: true,
            disabled: false,
            rules: [
              { validator: this.$wtValidator.ValidatorGreaterZeroFloat, trigger: 'blur' },
              { validator: this.$wtValidator.ValidatorEMax, trigger: 'blur' }
            ] },
          { name: '减少石油消耗(吨/个)',
            key: 'oil',
            type: 'text',
            required: true,
            disabled: false,
            rules: [
              { validator: this.$wtValidator.ValidatorGreaterZeroFloat, trigger: 'blur' },
              { validator: this.$wtValidator.ValidatorEMax, trigger: 'blur' }
            ] },
          { name: '是否在小程序显示',
            key: 'isShow',
            type: 'custom',
            required: false,
            disabled: false }]
      }
    }
  },
  created() {
    this.$store.dispatch('appendBreadcrumb', { meta: { title: this.componentType === 'edit' ? '编辑' : '新增' }})
  },
  methods: {
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
        this.$store.dispatch('removeBreadcrumb')
      } else if (item.action === 'ADD') {
        this.onAdd()
      } else if (item.action === 'EDIT') {
        this.onSave()
      }
    },
    onAdd() {
      const that = this
      this.$wtUtil.validateDetailFormsAndConfirm(this, '是否提交').then(() => {
        that.requestAddGarbageDeliveryTypeDetail()
      }).catch(() => {
      })
    },
    onSave() {
      const that = this
      this.$wtUtil.validateDetailFormsAndConfirm(this, '是否提交').then(() => {
        that.requestUpdateGarbageDeliveryTypeDetail()
      }).catch(() => {
      })
    },
    /*  ------------------------- 网络请求  -------------------------  */
    requestAddGarbageDeliveryTypeDetail() {
      const that = this
      const sendData = JSON.parse(JSON.stringify(this.detailFormData))
      sendData.type = 2
      // sendData.unitPrice = sendData.unitPrice * 100
      this.$wtUtil.postFormData({
        url: this.formAddUrl,
        formData: sendData,
        isLoading: this.isSubmitLoading
      }).then(resp => {
        that.$message({ message: '保存成功', type: 'success' })
        that.$emit('on-dialog-action', 'close')
        that.$emit('on-dialog-action', 'refresh')
      })
    },
    requestUpdateGarbageDeliveryTypeDetail() {
      const that = this
      const sendData = JSON.parse(JSON.stringify(this.detailFormData))
      // sendData.unitPrice = sendData.unitPrice * 100
      this.$wtUtil.postFormData({
        url: this.formUpdateUrl,
        formData: sendData,
        isLoading: this.isSubmitLoading
      }).then(resp => {
        that.$message({ message: '保存成功', type: 'success' })
        that.$emit('on-dialog-action', 'close')
        that.$emit('on-dialog-action', 'refresh')
      })
    },
    onWtDialogClose() {
      this.$emit('on-dialog-action', 'close')
    }
  },
  computed: {
    ...mapState({
      isGarbageDeliveryTypeDetailLoading: state => state.garbageDeliveryType.isGarbageDeliveryTypeDetailLoading,
      detailFormData: state => state.garbageDeliveryType.garbageDeliveryTypeDetailData
    })
  }
}
</script>

<style scoped>

</style>
